import { jsPDF } from "jspdf";
import { FONT_GRAPHIK_REGULAR_WEB_BASE64, FONT_GRAPHIK_MEDIUM_WEB_BASE64 } from "../_store/constants";
import { StateType } from './../_store/types';

/* Export Questions as a PDF */
const exportPdf  = (state: StateType) => {
  const { jobTitle } = state.interview;
  const DOC_FILENAME = jobTitle.length ? `Interview-${jobTitle.replace(/\s+/g, '-')}.pdf` : 'Interview.pdf';
    
  const CONSTANT = 1.33; // design is proportionally this constant smaller than letter size
  const IMAGE_CONSTANT = CONSTANT*2; // constant times double resolution of images

  /* units are px */
  const FONT_SIZE = 11;
  const LINE_HEIGHT = 1.25;
  const MARGIN_X = 88/CONSTANT;
  const MARGIN_Y = MARGIN_X;
  const CONTENT_DIMENSIONS = {
    W: 440, 
    H: 493*CONSTANT, 
    X: MARGIN_X,
    Y: 195,
  };
  const MAX_WIDTH = CONTENT_DIMENSIONS.W - (MARGIN_X * 2);

  const IMAGE_DATA = [
    {
      PATH: "/images/pages/interview-builder/InterviewBuilder--PDF--texture-bar.png",
      FILETYPE: "PNG",
      WIDTH: 1223/IMAGE_CONSTANT,
      HEIGHT: 16/IMAGE_CONSTANT,
      X: 0,
      Y: 0,
    },
    {
      PATH: "/images/pages/interview-builder/InterviewBuilder--PDF--full-logo.png",
      FILETYPE: "PNG",
      WIDTH: 252/IMAGE_CONSTANT,
      HEIGHT: 50/IMAGE_CONSTANT,
      X: 243/CONSTANT,
      Y: 28/CONSTANT,
    },
    {
      PATH: "/images/pages/interview-builder/InterviewBuilder--PDF--title-block.png",
      FILETYPE: "PNG",
      WIDTH: 640/IMAGE_CONSTANT,
      HEIGHT: 127/IMAGE_CONSTANT,
      X: 146/CONSTANT,
      Y: 81/CONSTANT,
    },
  ];

  const FONT_DATA = {
    GRAPHIK_REGULAR: {
      FILENAME: "Graphik-Regular-Web.ttf",
      SOURCE: FONT_GRAPHIK_REGULAR_WEB_BASE64,
      NAME: "GraphikRegularWeb",
      STYLE: "normal",
    },
    GRAPHIK_MEDIUM: {
      FILENAME: "Graphik-Medium-Web.ttf",
      SOURCE: FONT_GRAPHIK_MEDIUM_WEB_BASE64,
      NAME: "GraphikMediumWeb",
      STYLE: "bold"
    },
  }

  const INTERVIEW_QUESTIONS = state.interview.questions.map(questionId => state.questions[questionId]);

  // Create PDF doc
  const doc = new jsPDF({
    format: 'letter',
    unit: 'px',
  });

  // Add fonts 
  Object.entries(FONT_DATA).map(([key, fontData]) => {
    const { FILENAME, SOURCE, NAME, STYLE } = fontData;
    doc.addFileToVFS(FILENAME, SOURCE);
    doc.addFont(FILENAME, NAME, STYLE);
  })

  // Add images
  IMAGE_DATA.map(image => {
    const { PATH, FILETYPE, X, Y, WIDTH, HEIGHT } = image;
    doc.addImage(PATH, FILETYPE, X, Y, WIDTH, HEIGHT);
  })

  // Add content header and set font size
  doc.setTextColor('#3B64D2');
  doc.setFont(FONT_DATA.GRAPHIK_MEDIUM.NAME, FONT_DATA.GRAPHIK_MEDIUM.STYLE);
  doc.setFontSize(FONT_SIZE);
  doc.text('QUESTIONS', MARGIN_X, 169, {
    charSpace: 1.25
  });
  
  // Add custom title
  const jobTitleW = doc.getTextWidth(jobTitle);
  doc.text(jobTitle.toUpperCase(), CONTENT_DIMENSIONS.W - (MARGIN_X*1.5 + jobTitleW) , 169, {
    charSpace: 1.25
  });

  // Set content text color;
  doc.setTextColor('#1D2B36');
  doc.setFont(FONT_DATA.GRAPHIK_REGULAR.NAME, FONT_DATA.GRAPHIK_REGULAR.STYLE);

  // Accumulators to keep track of content line position
  let _currentYPos = 194;
  let _currentPageIndex = 1;
  let _allText = ``;
  let _currentAllTextHeight = 0;
  
  // Add questions to doc
   INTERVIEW_QUESTIONS.filter(question => question.textDefault?.length || question.textEdited?.length).map((question, index) => {
    const { textDefault, textEdited } = question;
    const QUESTION_TEXT = textEdited?.length ? textEdited : textDefault;

    let _text = `${index+1}. ${QUESTION_TEXT}`
    let _wrappedText = doc.splitTextToSize(_text , MAX_WIDTH)
    _allText = _allText + _text;
    
    // If current text height exceeds content boundaries, add and move to a new page
    if (_currentAllTextHeight > (CONTENT_DIMENSIONS.H - MARGIN_Y) * (CONSTANT*2))  {
      doc.addPage()
      _currentPageIndex++
      doc.setPage(_currentPageIndex)
      // reset text and position accumulators
      _allText = ``;
      _currentAllTextHeight = 0;
      _currentYPos = MARGIN_Y;
    } 

    // Text which has been wrapped
    if (_wrappedText.length > 1) {
      _wrappedText.map((line, lineIndex) => {
        doc.text(line, CONTENT_DIMENSIONS.X, _currentYPos, { 
          lineHeightFactor: LINE_HEIGHT,
          maxWidth: MAX_WIDTH
        })
        let _textDimensions = doc.getTextDimensions(line);
        _currentYPos += (lineIndex + 1) * (_textDimensions.h * LINE_HEIGHT)
      })
    } else { // A single line of text
      let _textDimensions = doc.getTextDimensions(_text);
      doc.text(_text, CONTENT_DIMENSIONS.X, _currentYPos, { 
        lineHeightFactor: LINE_HEIGHT,
        maxWidth: MAX_WIDTH
      })
      _currentYPos += (_textDimensions.h * LINE_HEIGHT * 2);
    }

    // Keep track of total text height of text so far. 
    let _currentAllTextDimensions = doc.getTextDimensions(_allText);
    let lineBreakCount = Math.floor(_currentAllTextDimensions.w / MAX_WIDTH);
    _currentAllTextHeight = _currentAllTextDimensions.h * lineBreakCount * FONT_SIZE * LINE_HEIGHT;
  });
 
  doc.save(DOC_FILENAME);
}

export default exportPdf